<div
  class="offcanvas offCanvasStart offcanvas-start"
  tabindex="-1"
  id="cadastralLayerPanel"
  aria-labelledby="cadastralLayerPanel"
>
  <div class="offcanvas-header">
    <div class="w-100">
      <div class="d-flex justify-content-between">
        <h2>Cadastral Layers</h2>
        <button
          type="button"
          class="btn btn-secondary btn-icon-only"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="offcanvas-body">
    <div class="w-100" id="scrollContainerTop">
      <ul class="list-unstyled ome-layers__list">
        <li
          class="d-flex mb-3 align-items-center"
          [ngClass]="{ 'all-cadastral': i === 1 }"
          *ngFor="let layer of cadastralDatasets; let i = index"
        >
          <div class="form-check d-flex flex-grow-1 align-items center">
            <input
              class="form-check-input"
              type="checkbox"
              [value]="layer.layerName"
              [checked]="layer.visible"
              (change)="onCheckboxChange(layer)"
              [attr.id]="layer.layerName"
              [disabled]="!layerInZoomRange(layer)"
            />
            <label class="form-check-label" [attr.for]="layer.layerName">
              {{ layer.displayName }}
            </label>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
